import React from 'react';
import {
  KeyboardAvoidingView,
  View,
  Platform,
  TouchableWithoutFeedback,
  Keyboard,
} from 'react-native';
import { isWeb } from '../../utils/Helper';

const KeyboardAvoidingWrapper = ({ children, style, keyboardVerticalOffset = 0 }) => {

  const dismissKeyboard = () => {
    Keyboard.dismiss();
  };

  return isWeb() ? (
    <>
      {children}
    </>
  ) : (
    <KeyboardAvoidingView
      style={[{ flex: 1 }, style]}
      behavior={Platform.OS === 'ios' ? 'padding' : 'padding'}
      keyboardVerticalOffset={keyboardVerticalOffset}
    >
      <TouchableWithoutFeedback onPress={dismissKeyboard}>
        {children}
      </TouchableWithoutFeedback>
    </KeyboardAvoidingView>
  );
};

export default KeyboardAvoidingWrapper;